import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumbs.css';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span className="breadcrumbs-separator">/</span>}
          {item.path ? (
            <Link to={item.path} className="breadcrumbs-item">
              {item.label}
            </Link>
          ) : (
            <span className="breadcrumbs-current">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};



